import { render, staticRenderFns } from "./DigitalReplyView.vue?vue&type=template&id=67308f8c&"
import script from "./DigitalReplyView.vue?vue&type=script&lang=js&"
export * from "./DigitalReplyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports